export default __webpack_public_path__ + "static/media/image27.994d3ea0.jpg";